import { network } from 'services/network';

import { QueryParams } from 'api/queries/getSummaryTrackedActivities.query';

export const getTrackedItems = (params: QueryParams) => {
    const payload = {
        compareVersionId: params.compareVersionId,
        contractId: params.contractId,
        latestVersionId: params.latestVersionId,
        projectId: params.projectId,
        filter: params.filter,
    };
    return network.post('api/bo/getTrackedItems', payload).then((response) => {
        return response.data;
    });
};
